import { render, staticRenderFns } from "./BannerViveLatino.vue?vue&type=template&id=1d33f999&scoped=true"
import script from "./BannerViveLatino.vue?vue&type=script&lang=js"
export * from "./BannerViveLatino.vue?vue&type=script&lang=js"
import style0 from "./BannerViveLatino.vue?vue&type=style&index=0&id=1d33f999&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d33f999",
  null
  
)

export default component.exports